import { render } from "./accessoire.vue?vue&type=template&id=c15237da&scoped=true"
import script from "./accessoire.vue?vue&type=script&lang=js"
export * from "./accessoire.vue?vue&type=script&lang=js"

import "./accessoire.vue?vue&type=style&index=0&id=c15237da&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c15237da"]])

export default __exports__